module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("He waited for a “Glad to meet you, too.” When none came, he went on, his hand still quieting Brighty. “My name’s Hezekiah Appleyard, but don’t nobody call me by that handle. What’s yours?”")])]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The stranger moved in closer. The firelight made his small black eyes and black beard gleam, and it picked out the red kerchief around his neck and splashed red on his face.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Name’s Irons,” he said. “Jake Irons, beaver trapper.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Now that’s what I calls a good, short, sensible handle,” the old man replied. “Folks calls me Old Timer. When I first heerd it, I looks around quick to see if some old guy’s behind me. When I seen they’s referrin’ to me, my hackles riz up.” He faced around to the fire and turned the hissing flapjacks. “I’m used to the label now. Fact is, I sorta like it. Makes me feel I’m a sure-’nough canyon man.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The hard black eyes were on the cakes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Ye needn’t just stand there gawpin’, Irons. Come! Share our chuck. It’ll be kinda nice to listen to man-talk fer a change, though Brighty here’s got a mighty sweet song fer a burro.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t mind if I do.” The stranger smiled, but only with his lips. His black beard parted briefly, flashing two gold teeth, very shiny.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The old man could not help admiring them. “I come down here to the canyon seekin’ gold,” he said, “but I guess gold ain’t the onliest way to get rich.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The pin eyes gave the prospector a sly glance. Then, going over to a flat rock, Irons slapped down the beaver and took out his hunting knife.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("“Go ahead, skin out yer beaver,” Old Timer said, “but don’t ")]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("ye flaunt the smell in front o’ Brighty. He don’t like hot meat, nor meat of any kind, fer that matter.”")])]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Jake Irons knelt in the sand and with nimble fingers skinned the beaver, setting aside the choice bits of meat. Before anyone could say scat, a ring-tailed cat leaped up on the rock and made off with the liver.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "height": "310",
      "src": "images/f0021-01.jpg",
      "width": "550"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Ain’t she quick, though!” The old man slapped his thigh in admiration. “Her name’s Wait-a-minute, ’cause she never does. Oh, well, ye still got the pelt, and that’s what ye’re after.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Muttering to himself, Jake Irons stretched the beaver skin, using stones to hold it in place. As he turned around he almost bumped into Brighty, who stood with hindquarters hunched, threatening to let his heels fly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Reckon he’s just a mite jealous about sharin’ his supper,” the old man laughed. “Leastawise, that’s what I hope.”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e5432b6e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch02b.vue
// module id = 81
// module chunks = 0